import React from 'react';
import { SvgIcon } from 'seduo-ui';
const Example = () => (<section className="mb-9 card">
        <div className="card-body">
            <div className="row pb-7 flex-sm-row-reverse align-items-center">
                <div className="col-12 col-sm-auto text-center text-sm-right mb-6 mb-sm-0">
                    <SvgIcon kind="FinishedEducationProgram" width={86} height={57}/>
                </div>
                <div className="col-12 col-sm text-center text-sm-left">
                    <strong className="font-weight-medium text-title">Program byl úspěšně dokončen 24.06.2021</strong>
                </div>
            </div>
            <a href="#" className="btn btn-primary btn-large btn-block">
                Stáhnout certifikát
            </a>

            <button className="btn btn-outline-primary btn-large btn-block">Doporučit kolegovi</button>

            <div className="text-center px-6 pt-6">
                <a href="#" className="btn btn-link text-muted">
                    Spustit znovu
                </a>
            </div>
        </div>
    </section>);
export default Example;
